import Bastille from "../../img/media/bastille.png"
import Nineteen from "../../img/media/2019.png"
import Events from "../../img/media/events.png"
import Eighteen from "../../img/media/2018.png"

export const MediaData = [
    {
        name: "Bastille",
        description:
            "",
        link: "",
        image: Bastille,
    },
    {
        name: "Nineteen",
        description:
            "",
        link: "",
        image: Nineteen,
    },
    {
        name: "Events",
        description:
            "",
        link: "",
        image: Events,
    },
    {
        name: "Eighteen",
        description:
            "",
        link: "",
        image: Eighteen,
    },
]
